module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAD6SURBVHjarJShTgNBFEVPtxWQ4KlAtJ/Q8AVNKoBg+AQsCYYKfD8AjcCSVGFA4LFFgarBgGkhKeAI7MGwZru7YaZ7kjFvMiczd14ealM9U9/VmXqsErJQT1xmN0SSADsss0cACbBeUG+GSlamFkmrpL4FDCrOvQIPwA8A6p1xTNSN7Hdi2QaGdWTSqUNyVRXsx194ZSyAC+C6SnIJHK3aJ0los83LAguRPBfUB0D/v5KGepClnOMLGANT4Du3lwKPwC0gakt9iuza82wooe6raYQkVbvZL9wApxHN1gA286PuUP0MuMmLulY0M9vqSL1X3yqeMVF7Kr8DALBjxUh6A60ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/page-footer/page-png/twitter.png
// module id = ./src/components/page-footer/page-png/twitter.png
// module chunks = index